"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddRowToGroupModel = exports.AddRowModel = exports.TableModel = void 0;
const vue_1 = __importDefault(require("vue"));
const _ = __importStar(require("lodash"));
const debug_1 = __importDefault(require("debug"));
const sort_1 = require("./sort");
const messages_1 = require("../messages");
const pager_1 = require("./pager");
const row_model_1 = require("./row-model");
const row_group_model_1 = require("./row-group-model");
const slot_row_model_1 = require("./slot-row-model");
const footer_totals_row_model_1 = require("./footer-totals-row-model");
const log = (0, debug_1.default)('itp.ui.datatable.model');
const NEW_ROW_PREFIX = '$$newrow$$_';
class TableModel {
    eventBus;
    pager;
    sorter;
    rowKeyField;
    useIndexAsRowKey;
    options;
    component;
    VM_SPACER;
    VM_RULER;
    VM_AFTER_LAST_ROW;
    columnsByName;
    componentMounted;
    lang;
    messages;
    rows;
    view;
    editingRow;
    get empty() {
        return !this.rows || this.rows.length === 0;
    }
    constructor(options, component) {
        this.VM_SPACER = new slot_row_model_1.SlotRowModel('spacer', { table: this }, { trClass: 'itp-datatable__spacer', tdClass: 'border-0' });
        this.VM_RULER = new slot_row_model_1.SlotRowModel('spacer', { table: this }, { trClass: 'itp-datatable__spacer', ruler: true });
        this.VM_AFTER_LAST_ROW = new slot_row_model_1.SlotRowModel('afterLastRow', { table: this }, { trClass: 'itp-datatable__close', tdClass: 'border-0' });
        this.component = component;
        this.componentMounted = false;
        this.options = options;
        this.eventBus = new vue_1.default();
        this.useIndexAsRowKey = options.useIndexAsRowKey || false;
        this.rowKeyField = options.rowKeyField;
        this.lang = options.lang;
        this.messages = _.extend((0, messages_1.getMessages)(), options.messages);
        this.editingRow = null;
        this.pager = new pager_1.Pager({
            enabled: options.paging || false,
            totalSize: 0,
            pageSize: 10,
            eventBus: this.eventBus
        });
        this.sorter = new sort_1.TableSorter();
        this.updateRows(options.rows, false);
        this.updateView({ trigger: 'constructor' });
        this.eventBus.$on('updateView', (args) => this.updateView(args));
        this.eventBus.$on('rowSelectionChanged', () => this.onRowSelectionChanged());
        this.columnsByName = _.reduce(this.options.columns, (m, column, index) => _.set(m, column.name, { index, column }), {});
    }
    get editorFormId() {
        return 'tableEditor';
    }
    get rowDetailsIsEnabled() {
        return this.rowDetailsIsExpandable || this.rowDetailsIsAlwaysVisible;
    }
    get rowDetailsIsAlwaysVisible() {
        return this.options.rowDetailsMode === 'alwaysVisible';
    }
    get rowDetailsIsExpandable() {
        return this.options.rowDetailsMode === 'expandable';
    }
    get headerIsVisible() {
        const hm = this.options.headerMode;
        if (hm === 'editorVisible') {
            return this.isEditing;
        }
        if (hm === 'hidden') {
            return false;
        }
        return true;
    }
    get isEditable() {
        return this.options.editable;
    }
    get isEditing() {
        return !!this.editingRow;
    }
    get isSortable() {
        return this.options.sortable;
    }
    get canCreateRow() {
        return this.isEditable && this.options.canCreateRow;
    }
    get addSpacerRow() {
        return this.rowDetailsIsEnabled;
    }
    get defaultHeaderTextAlign() {
        return this.options.headerTextAlign || 'left';
    }
    get defaultTextAlign() {
        return this.options.textAlign || 'left';
    }
    updateRows(items, updateView = true) {
        this.editingRow = null;
        this.rows = _.map(items, p => new row_model_1.RowModel(this, p));
        if (!this.useIndexAsRowKey) {
            this.checkRowKeys();
        }
        this.pager.setTotalSize(this.rows.length);
        if (updateView) {
            this.updateView({ trigger: 'updateRows' });
        }
    }
    updateGroups(groups) {
        this.options.groups = groups;
        this.updateView({ trigger: 'updateGroups' });
    }
    sortRows(col) {
        if (!col.sortable || !this.isSortable) {
            return false;
        }
        col.sort = (0, sort_1.toggleSort)(col.sort || 0);
        this.sorter.updateSortColumn(col.field || col.name, col.sort);
        this.rows = this.sorter.sortItems(this.rows);
        this.updateView({ trigger: 'sortRows' });
    }
    replaceRow(oldRow, newRow) {
        log('replaceRow %o => %o', oldRow, newRow);
        const startIdx = this.findRowIndex(oldRow);
        log('start index: %d', startIdx);
        this.rows.splice(startIdx, 1, newRow);
        this.rows = this.rows.slice();
        this.updateView({ trigger: 'replaceRow' });
    }
    previousRow(row) {
        const idx = this.findRowIndex(row);
        if (idx != null && idx > 0) {
            return this.rows[idx - 1];
        }
    }
    nextRow(row) {
        const idx = this.findRowIndex(row);
        if (idx != null && idx < this.rows.length - 2) {
            return this.rows[idx + 1];
        }
    }
    nearestRow(row) {
        return this.previousRow(row) || this.nextRow(row);
    }
    removeRow(row) {
        this.rows.splice(this.findRowIndex(row), 1);
        this.rows = this.rows.slice();
        this.updateView({ trigger: 'removeRow' });
    }
    isRowEditable(row) {
        return (this.isEditable &&
            !this.isEditing &&
            this.options.checkRowAction('edit', row));
    }
    isRowDeletable(row) {
        return (this.isEditable &&
            !this.isEditing &&
            this.options.checkRowAction('delete', row));
    }
    beginEdit(row) {
        const idx = this.rowIndex(row);
        this.beginEditRow(idx, row);
    }
    addNewRow(group) {
        const extras = {};
        if (group && this.options.groupKeyField) {
            extras[this.options.groupKeyField] = _.isEmpty(group.id)
                ? null
                : group.id;
        }
        this.beginEditRow(-1, new row_model_1.RowModel(this, this.getEmptyRow(extras)));
    }
    applyEdit(row) {
        const editingRow = this.editingRow;
        if (!editingRow || editingRow !== row) {
            return;
        }
        editingRow.endEdit().then(p => {
            if (p) {
                this.editingRow = null;
                this.updateView({ trigger: 'applyEdit' });
            }
        });
    }
    cancelEdit(row) {
        const editingRow = this.editingRow;
        if (!editingRow || editingRow !== row) {
            return;
        }
        if (editingRow.isNew) {
            this.rows.splice(this.rows.length - 1, 1);
        }
        editingRow.endEdit(true).then(p => {
            this.editingRow = null;
            this.updateView({ trigger: 'endEdit' });
        });
    }
    deleteRow(row) {
        if (this.isEditing) {
            return;
        }
        row.delete();
    }
    getCellClass(col, row) {
        let result = {};
        let value = this.options.cellClass;
        if (_.isFunction(value)) {
            value = value(row, _.get(row, col.field));
        }
        if (_.isString(value)) {
            _.each(value.trim().split(' '), p => _.set(result, p, true));
        }
        return result;
    }
    *iterRows(group) {
        let gKey = null;
        if (this.options.groups && this.options.groupKeyField) {
            gKey = this.options.groupKeyField;
        }
        for (let row of this.rows) {
            if (group == null) {
                yield row;
                continue;
            }
            const groupKey = gKey ? _.get(row, gKey, '') : '';
            if (group == '' && (groupKey == null || groupKey === '')) {
                yield row;
                continue;
            }
            if (groupKey === group) {
                yield row;
            }
        }
    }
    get selectedRows() {
        return _.filter(this.rows, { selected: true });
    }
    onRowSelectionChanged() {
        this.component.$emit('selectedRowsChanged', {
            selection: this.selectedRows
        });
    }
    beginEditRow(idx, row) {
        if (this.isEditing) {
            return;
        }
        if (idx === -1) {
            this.rows.push(row);
        }
        this.editingRow = row;
        row.beginEdit();
        this.updateView({ trigger: 'beginEditRow' });
    }
    findRowIndex(row) {
        if (this.useIndexAsRowKey) {
            throw new Error('This method is not supported when `useIndexAsRowKey` option is enabled.');
        }
        const key = this.getRowKey(row), idx = _.findIndex(this.rows, { [this.rowKeyField]: key });
        if (idx < -1) {
            throw new Error(`Row not found by key "${key}"`);
        }
        return idx;
    }
    rowIndex(row) {
        if (this.useIndexAsRowKey) {
            return _.indexOf(this.rows, row);
        }
        const key = this.getRowKey(row);
        return _.findIndex(this.rows, { [this.rowKeyField]: key });
    }
    getRowKey(row) {
        if (this.useIndexAsRowKey) {
            return _.indexOf(this.rows, row);
        }
        return _.get(row, this.rowKeyField);
    }
    getColumnIndex(col) {
        return this.columnsByName[col.name].index;
    }
    *generateView() {
        if (this.options.groups && this.options.groupKeyField) {
            const groups = [row_group_model_1.RowGroupModel.empty()].concat(_.map(this.options.groups, p => new row_group_model_1.RowGroupModel(p, []))), groupsByKey = _.reduce(groups, (m, p) => ((m[p.id] = p), m), {}), groupKeyField = this.options.groupKeyField;
            for (let row of this.rows) {
                const key = _.get(row, groupKeyField, null);
                if (key != null) {
                    const target = groupsByKey[key];
                    if (target) {
                        target.rows.push(row);
                        continue;
                    }
                }
                groups[0].rows.push(row);
            }
            if (this.addSpacerRow) {
                yield this.VM_SPACER;
            }
            for (let g of groups) {
                yield g;
                for (let row of g.rows) {
                    if (this.addSpacerRow) {
                        yield this.VM_SPACER;
                    }
                    yield row;
                }
                if (this.canCreateRow) {
                    yield this.VM_SPACER;
                    yield new AddRowToGroupModel(this, g);
                }
                if (this.options.footerTotals && g.rows.length > 1) {
                    yield new footer_totals_row_model_1.FooterTotalsRowModel(this, g);
                }
                yield this.VM_RULER;
            }
            if (this.rows.length) {
                yield this.VM_AFTER_LAST_ROW;
            }
            return;
        }
        if (this.addSpacerRow) {
            yield this.VM_SPACER;
        }
        for (let row of this.rows) {
            yield row;
        }
        if (this.canCreateRow) {
            yield this.VM_SPACER;
            yield new AddRowModel(this);
        }
        if (this.rows.length) {
            yield this.VM_AFTER_LAST_ROW;
        }
        if (this.options.footerTotals && this.rows.length > 1) {
            yield new footer_totals_row_model_1.FooterTotalsRowModel(this);
        }
    }
    updateView(args) {
        console.log('updateView', args);
        this.view = this.pager.enabled
            ? this.pager.currentPageSlice(this.rows)
            : [...this.generateView()];
    }
    checkRowKeys() {
        const keys = [];
        if (!this.rows) {
            return;
        }
        for (let item of this.rows) {
            let k = _.get(item, this.rowKeyField, null);
            if (k === null) {
                throw new Error(`Row key error: "${this.rowKeyField}" is null. ${item}`);
            }
            if (keys.indexOf(k) > -1) {
                throw new Error(`Duplicate row key: "${k}". Keys must be unique.`);
            }
            keys.push(k);
        }
    }
    getEmptyRow(extras) {
        const result = _.extend({}, this.options.rowTemplate, extras);
        for (let column of this.options.columns) {
            if (!column.readonly) {
                const field = column.field || column.name;
                if (!_.isUndefined(column.default)) {
                    result[field] = getValue(column.default);
                    continue;
                }
                if (!(field in result)) {
                    result[field] = null;
                }
            }
        }
        return result;
    }
}
exports.TableModel = TableModel;
function getValue(value) {
    if (_.isFunction(value)) {
        return value();
    }
    return value;
}
class AddRowModel {
    isAddRow;
    trClass;
    id;
    table;
    constructor(table) {
        this.isAddRow = true;
        this.id = `table__cmd_add`;
        this.table = table;
    }
    execute(ev) {
        this.table.addNewRow();
    }
}
exports.AddRowModel = AddRowModel;
class AddRowToGroupModel {
    isAddRowToGroup;
    id;
    table;
    group;
    constructor(table, group) {
        this.isAddRowToGroup = true;
        this.id = `${group.id}__cmd_add`;
        this.table = table;
        this.group = group;
    }
    execute(ev) {
        this.table.addNewRow(this.group);
    }
}
exports.AddRowToGroupModel = AddRowToGroupModel;
//# sourceMappingURL=table-model.js.map